module.exports = __webpack_public_path__ + "static/media/save-as-template-popup.2418cd83.png";